import React, { useCallback, useState } from 'react'
import { useParams } from 'react-router-dom'

import { AppLayout, FormWrapper, LanguageSelector } from '@/components'
import { IProposal } from '@/types'
import { print } from '@/utils'
import { t } from '@/i18n'

import { useData } from './useData'
import Form from './form'

const EditProposal: React.FC = () => {
  const { id = '' } = useParams()
  const [isEditing, setIsEditing] = useState<boolean>(true)
  const { data, loading, submitting, onDelete, onSubmit } = useData({ id })

  const onSubmitForm = useCallback(
    (d: IProposal) => {
      // @ts-ignore
      onSubmit(`deals/proposal/${id}/`, true, () => setIsEditing(false))(d)
    },
    [id, onSubmit],
  )

  return (
    <AppLayout
      hasFooter
      headerRight={
        <div className="app-right-container">
          <LanguageSelector />
        </div>
      }
    >
      <FormWrapper
        breadcrumbs={[{ name: isEditing ? 'edit_proposal' : 'view_proposal' }]}
        objectName={t('proposal')}
        loading={loading}
        isEditing={isEditing}
        onEdit={() => setIsEditing(true)}
        onDelete={() => onDelete(id)}
        extraButtons={[
          {
            text: t('print'),
            className: 'print-form-button',
            onClick: () => print('proposal', id),
          },
        ]}
      >
        <div className="content-box">
          <div className="scroll-wrap">
            <div className="content-title">
              <h2>
                {isEditing
                  ? t('edit_proposal_label', { label: data.id })
                  : t('view_proposal')}
              </h2>
            </div>
            <Form
              isEditing={isEditing}
              initialData={data}
              loading={loading}
              submitting={submitting}
              onCancel={() => setIsEditing(false)}
              onSubmit={onSubmitForm}
            />
          </div>
        </div>
      </FormWrapper>
    </AppLayout>
  )
}

export default EditProposal
